import React from "react";
import precio from "../../assets/image/stella/precios.png";
import imagen from "../../assets/image/stella/downloadpromo.png";
import {HashLink} from "react-router-hash-link";

function Section3() {
    return (
        <section className="relative py-20">
            <div
                className="absolute inset-0  bg-contain bg-repeat-y opacity-20 z-0"
                style={{
                    backgroundImage: `linear-gradient(180deg, #00000085, #141414), url(${precio})`,
                }}></div>
            <div className="relative container px-5 grid md:grid-cols-2 gap-10 z-10"><img
                alt="ofertas stella tv" loading="lazy" width="500" height="400" decoding="async" data-nimg="1"
                className="w-[35%] mx-auto h-auto rounded-[10px] intersect:animate-in slide-in-from-left intersect-once duration-1250 filterimg"
                src={imagen}/>
                <div
                    className="max-md:text-center pt-5 md:pt-10 intersect:animate-in slide-in-from-right intersect-once duration-1250">
                    <h3 className="text-2xl md:text-[30px] uppercase font-semibold leading-tight">Suscríbete al mejor
                        precio del mercado</h3><p className="mt-3 leading-relaxed text-white">Podrás disfrutar de más de 1600
                    canales de televisión de todo el mundo en hasta 3 pantallas simultáneamente, además de cientos de
                    películas y series desde cualquier dispositivo Android.</p><p
                    className="mt-3 leading-relaxed text-white">Ofrecemos contenido variado, incluyendo canales para adultos,
                    anime, música y mucho más.</p>
                    <HashLink to='/#planes'
                    className="btn-primary mt-8 inline-flex gap-1 px-8 py-3 text-base font-semibold text-white no-underline">
                    CONTRATAR</HashLink>
                </div>
            </div>
        </section>
    );
}

export default Section3;
